import React from "react";
import { Synchronized } from "../common/Synchronized";
import { BookingCard } from "../common/BookingCard";
import management from "../../../../common/utilities/Management";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../common/state/model/ApplicationState";

export function Step36(): React.JSX.Element {
  const allowHealthInformationOnTreatment = useSelector((state: ApplicationState) => state.common?.config?.allowHealthInformationOnTreatment);

  return (
    <BookingCard>
      <Synchronized showMedicalInformation={management.partnerAdapter.showMedicalInformationForTreatmentPlan(allowHealthInformationOnTreatment)} />
    </BookingCard>
  );
}
